import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import { Link as RouterLink } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { SxProps } from '@mui/system';
// import { useHistory } from 'react-router-dom';
import Box from '@mui/material/Box';

interface NavItem {
  title: string;
  path?: string;
  description?: string;
}

interface NavigationGuideProps {
  title?: string;
  items: NavItem[];
  hasTwoColumn?: boolean;
  isSingleLine?: boolean;
  hasIcon?: boolean;
  compact?: boolean;
  sx?: SxProps<Theme>;
  onClose?: () => void;
}

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    listItem: {
      '& button': {
        visibility: 'hidden',
      },
      '&:hover': {
        color: theme.palette.primary.main,
        backgroundColor: 'transparent',
        '& button': {
          visibility: 'visible',
        },
      },
    },
  }),
  { name: 'NavigationGuide' },
);

// const ListItemRouter = (props: any) => {
//   return (
//     <ListItem
//       button
//       {...props}
//       // component={RouterLink}
//     />
//   );
// };

const NavigationGuide: React.FC<NavigationGuideProps> = ({ title, items, compact = false, hasTwoColumn = false, isSingleLine = true, hasIcon = false, sx, onClose }) => {
  const classes = useStyles();
  // const history = useHistory();

  return (
    <Stack sx={sx}>
      {title && (
        <Typography variant="body1" sx={{ pb: 1, fontWeight: 500 }}>
          {/* Replace spaces with a non-breaking space `\u00A0` to prevent the title flowing over multiple lines. TCN-826 */}
          {title.replace(/ /g, '\u00A0')}
        </Typography>
      )}
      <Stack direction={hasTwoColumn ? 'row' : 'column'} flexWrap="wrap">
        {items.map((item: any, idx: number) => {
          if (item.title === 'spacer') return <Box key={idx} sx={{ minHeight: 20 }} />;
          return (
            <Stack sx={{ width: hasTwoColumn ? '50%' : '100%' }} key={idx}>
              <ListItem
                sx={{
                  color: 'text.secondary',
                  p: 0,
                }}
                button
                component={RouterLink}
                to={item.path}
                className={classes.listItem}
                onClick={() => {
                  onClose && onClose();
                  // history.push(item.path);
                }}
              >
                <ListItemText
                  primary={compact ? item.title.replace('Gifts for', ' ').trim() : item.title}
                  secondary={item.description ? item.description : null}
                  primaryTypographyProps={{
                    fontSize: '16px',
                  }}
                  secondaryTypographyProps={{
                    fontSize: '14px',
                  }}
                />
                {hasIcon && (
                  <IconButton edge="end" aria-label="forward" sx={{ right: 0 }}>
                    <ArrowForwardIcon />
                  </IconButton>
                )}
              </ListItem>
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default NavigationGuide;
